import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./pagination.css";

interface PageButtonProps {
  page: number;
  currentPage: number;
  totalPages: number;
  handlePage: (page: number) => void;
}

function PageButton({
  page,
  currentPage,
  totalPages,
  handlePage,
}: PageButtonProps) {
  return (
    <button
      className={`pagination-button rounded-1 ${
        page === currentPage ? "pagination-active-btn" : ""
      }`}
      disabled={totalPages < 1 || page === currentPage}
      onClick={() => handlePage(currentPage)}
    >
      {currentPage}
    </button>
  );
}

interface PaginationControls {
  page: number;
  limit: number;
  handlePage: (p: number) => void;
  handleLimit: (l: number) => void;
}
interface Props {
  total: number;
  pagination: PaginationControls;
}

export default function Pagination({ total, pagination }: Props) {
  const { t } = useTranslation(["components"]);
  const { page, limit, handlePage, handleLimit } = pagination;
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    setTotalPages(Math.ceil(total / limit));
  }, [total, limit]);

  const optionsArray = Array.from(
    { length: Math.ceil(total / 10) },
    (_, index) => (index + 1) * 10
  );

  const generatePageNumbers = (start: any, end: any) => {
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  return (
    <div className="d-flex align-items-center justify-content-between pagination-cont bg-white p-3 mb-5">
      <div className="d-flex align-items-center">
        <span>{t("pagination.show", { ns: "components" })}</span>
        <div className="">
          <select
            className="border-0 pagination-dropdown rounded-1 px-2 py-1"
            name=""
            id=""
            value={limit}
            onChange={(e) => handleLimit(Number.parseInt(e.target.value))}
          >
            {optionsArray.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <span>{t("pagination.entries", { ns: "components" })}</span>
      </div>

      <div className="pagination-btn-cont">
        <button
          className="navigate-btn"
          disabled={page - 1 < 1}
          onClick={() => handlePage(page - 1)}
        >
          {t("pagination.previous_button", { ns: "components" })}
        </button>
        {generatePageNumbers(1, totalPages).map((pageNumber) => (
          <PageButton
            key={pageNumber}
            currentPage={pageNumber}
            page={page}
            totalPages={totalPages}
            handlePage={handlePage}
          />
        ))}
        <button
          className="navigate-btn"
          disabled={page + 1 > totalPages}
          onClick={() => handlePage(page + 1)}
        >
          {t("pagination.next_button", { ns: "components" })}
        </button>
      </div>
    </div>
  );
}
